import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgChat = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", {
			fill: "#4384F5",
			fillRule: "nonzero",
			d: "M12.333.333H1.667C.933.333.333.933.333 1.667v12L3 11h9.333c.734 0 1.334-.6 1.334-1.333v-8c0-.734-.6-1.334-1.334-1.334z"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M-1-1h16v16H-1z",
			opacity: .7
		})]
	})
});
export default SvgChat;
